<template>
  <div class="calculator-display" :class="interacting ? 'calculator-display--interacting' : ''">
    <div class="calculator-display__input" data-test-id="calculator-input">
      <template v-if="interacting">
        Ans = {{ prettyOutput || '0' }}
      </template>
      <template v-else>
        <span v-safe-html="prettyExpression ? `${prettyExpression} =` : ''" />
      </template>
    </div>
    <span class="sr-only">{{ $t('web.widgets.calculator.result') }}</span>
    <output class="calculator-display__output" data-test-id="calculator-output" tabindex="0">
      <EError v-if="error" class="calculator-display__error">
        {{ $t(`web.widgets.calculator.error.${error.translationKey}`) }}
      </EError>
      <template v-else-if="interacting"><span v-safe-html="prettyExpression" /></template>
      <template v-else-if="prettyOutput"><span v-safe-html="prettyOutput" /></template>
      <template v-else>0</template>
    </output>
  </div>
</template>

<script>
import EError from '~~/common/vue/components/error';

import postprocess from './post-processing';

export default {
  name: 'ECalculatorDisplay',
  components: {
    EError,
  },
  props: {
    expression: {
      type: String,
      default: '',
    },
    output: {
      type: String,
      default: '',
    },
    interacting: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [Error, null],
      default: null,
    },
  },
  computed: {
    prettyExpression() {
      return postprocess(this.expression);
    },
    prettyOutput() {
      return postprocess(this.output);
    },
  },
};
</script>

<style lang="scss" scoped>
.calculator-display {
  background: var(--color-background-primary);
  border: solid $border-width var(--color-form-border-default);
  border-radius: $border-radius-s;
  margin-bottom: $space-1s;
  padding: $space-m;
  overflow: hidden;
}

.calculator-display__input,
.calculator-display__output {
  display: flex;
  justify-content: flex-end;
  line-height: 1;
}

.calculator-display__input {
  color: var(--color-text-secondary);
  font-size: $font-l;
  min-height: 1em;
}

.calculator-display__output {
  font-size: $font-4l;
  font-weight: $font-weight-l;
  margin-top: $space-1s;
  min-width: 0;

  @include tablet {
    font-size: $font-5l;
  }
}

.calculator-display__error {
  font-size: inherit;
  line-height: inherit;
}
</style>
